/*
  L'ARTISTE — le parcours en chapitres
  Pour Adrien d'Elzius · page L'artiste

  Un clic sur un chapitre l'affiche à côté (ou dessous, sur téléphone).
  « Chapitre suivant » enchaîne la lecture ; ← → aussi, depuis la liste.
  Sans script, tous les chapitres restent lisibles les uns sous les autres.
*/
(function () {
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(story) {
    if (story.__art) return;
    story.__art = 1;
    var chaps = $$('[data-art-chap]', story);
    var panels = $$('[data-art-panel]', story);
    var liste = story.querySelector('.art__chapters');
    if (!chaps.length) return;
    var cur = 0;
    var calme = window.matchMedia('(prefers-reduced-motion: reduce)');

    function montrer(i, focaliser, depuisClic) {
      i = (i + chaps.length) % chaps.length;
      cur = i;
      chaps.forEach(function (c, k) {
        var on = k === i;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (p, k) {
        var on = k === i;
        p.classList.toggle('is-on', on);
        if (on) p.removeAttribute('inert'); else p.setAttribute('inert', '');
      });
      // Sur la frise de téléphone, le chapitre choisi revient en vue,
      // calé sur la marge de la page (pas au premier affichage).
      if (depuisClic && liste && liste.scrollWidth > liste.clientWidth) {
        var marge = parseFloat(getComputedStyle(liste).paddingLeft) || 0;
        liste.scrollTo({ left: Math.max(0, chaps[i].parentNode.offsetLeft - marge), behavior: calme.matches ? 'auto' : 'smooth' });
      }
      if (focaliser) chaps[i].focus({ preventScroll: true });
    }

    chaps.forEach(function (c, i) {
      c.addEventListener('click', function () { montrer(i, false, true); });
      c.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); montrer(i + 1, true, true); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); montrer(i - 1, true, true); }
      });
    });
    $$('[data-art-next]', story).forEach(function (b) {
      b.addEventListener('click', function () {
        montrer(cur + 1, false, true);
        // Le texte suivant prend la place : on garde le chapitre sous les yeux.
        var p = panels[cur];
        if (p && p.getBoundingClientRect().top < 0) p.scrollIntoView({ block: 'start', behavior: calme.matches ? 'auto' : 'smooth' });
      });
    });
    montrer(0);
    // Le fondu entre chapitres ne commence qu'après le premier affichage.
    requestAnimationFrame(function () { story.classList.add('is-ready'); });
  }

  function demarrer(scope) { $$('[data-art-story]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); });
  else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
